import {ICartPosition} from "../../../typescript-library";
import * as React from "react";
import {useTranslation} from "react-i18next";

interface IItemPriceProps {
  position: ICartPosition;
}

const ItemPrice: React.FC<IItemPriceProps> = (props) => {
  const {amount, amountRetail, item} = props.position;
  const {t} = useTranslation();
  const whitespaceWrapping = (str: string) => str.replace(/\s/g, "\u00A0");
  const basePrice = item?.prices?.[0]?.basePrice || null;

  if (amountRetail) {
    return (
      <React.Fragment>
        <span style={{textDecoration: "line-through"}}>
          {t("general.rrp--price", {price: whitespaceWrapping(amountRetail.formatted)})}
        </span>{" "}
        <strong style={{color: "red"}}>{whitespaceWrapping(amount.formatted)}</strong>
        {basePrice && <span style={{whiteSpace: "nowrap"}}>{whitespaceWrapping(basePrice)}</span>}
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <strong>{amount.amount === "0.00" ? t("general.free") : amount.formatted}</strong>
      {basePrice && <span style={{whiteSpace: "nowrap"}}>{whitespaceWrapping(basePrice)}</span>}
    </React.Fragment>
  );
};

export default ItemPrice;
